import {IRouteChanged, subscribeToRouteChanged} from "./eventBus/route/routeEventBus";

export function generateUUID() {
  let d = new Date().getTime() + performance.now();
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return guid;
}

/**
 * Since we don't have access to a head element in native, and we want a single source of truth, disable zoom via js.
 */
export function disableZoom(){
  const meta = document.createElement('meta');
  meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, shrink-to-fit=no');
  meta.setAttribute('name', 'viewport');
  document.getElementsByTagName('head')[0].appendChild(meta);
}


export function routeLocation(locationPath: string, onRouteEnter: (message: IRouteChanged) => (void | ((message: IRouteChanged) => void) )){
  let onRouteLeave: (void | ((message: IRouteChanged) => void) );
  return subscribeToRouteChanged((message: IRouteChanged) =>{
    if(message.locationPath === locationPath){
      onRouteLeave = onRouteEnter(message);
    }else{
      onRouteLeave && onRouteLeave(message);
    }
  });
}

